module.exports = __webpack_public_path__ + "static/media/f_eyeshape_downturned_darkbrown.0fe1c01f.png";